import { InvoicingActionTypes } from "./actionTypes";

const initialState = {
    invoicingListError: null, message: null,
    query: {
        page: 1,
        pageSize: 20,
        search: ''
    }
}

const Invoicing = (state = initialState, action) => {
    switch (action.type) {

        case InvoicingActionTypes.INVOICING_LIST_GET:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: null
            }
            break;
        case InvoicingActionTypes.INVOICING_LIST_GET_SUCCESSFUL:
            state = {
                ...state,
                invoicingList: action.payload,
                invoicingListError: null
            }
            break;
        case InvoicingActionTypes.INVOICING_LIST_GET_ERROR:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: action.payload
            }
            break;


        case InvoicingActionTypes.INVOICING_GET_FILTERED:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: null
            }
            break;
        case InvoicingActionTypes.INVOICING_GET_FILTERED_SUCCESSFUL:
            state = {
                ...state,
                invoicingList: action.payload,
                invoicingListError: null
            }
            break;
        case InvoicingActionTypes.INVOICING_GET_FILTERED_ERROR:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: action.payload
            }
            break;


        case InvoicingActionTypes.INVOICING_CREATE:
            state = {
                ...state,
                isLoadingAddInvoicing: true
            }
            break;
        case InvoicingActionTypes.INVOICING_CREATE_SUCCESS:
            state = {
                ...state,
                isLoadingAddInvoicing: false,
            }
            break;
        case InvoicingActionTypes.INVOICING_CREATE_ERROR:
            state = {
                ...state,
                isLoadingAddInvoicing: false,
            }
            break;

        case InvoicingActionTypes.SET_INVOICING_QUERY:
            state = {
                ...state,
                query: { ...state.query, ...action.payload }
            }
            break;
        case InvoicingActionTypes.RESET_INVOICING_QUERY:
            state = {
                ...state,
                query: initialState.query
            }
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

const initialInvoiceState = {
    invoicingListError: null, message: null,
    query: {
        page: 1,
        pageSize: 20,
        search: ''
    }
}

const Invoices = (state = initialInvoiceState, action) => {
    switch (action.type) {
        
        case InvoicingActionTypes.INVOICE_LIST_GET:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: null
            }
            break;
        case InvoicingActionTypes.INVOICE_LIST_GET_SUCCESSFUL:
            state = {
                ...state,
                invoicingList: action.payload,
                invoicingListError: null
            }
            break;
        case InvoicingActionTypes.INVOICE_LIST_GET_ERROR:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: action.payload
            }
            break;

        case InvoicingActionTypes.SET_INVOICE_QUERY:
            state = {
                ...state,
                query: { ...state.query, ...action.payload }
            }
            break;
        case InvoicingActionTypes.RESET_INVOICE_QUERY:
            state = {
                ...state,
                query: initialInvoiceState.query
            }
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default Invoicing;
export {Invoicing, Invoices};
